import React, { useState, useEffect, useRef } from 'react'; //import React Component
import { NavLink } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { cloudStore } from '../firebase';
import { collection, query, where, getDocs, updateDoc, doc, increment, setDoc, arrayUnion, getDoc } from 'firebase/firestore';

export function SummaryPrice() {
    let eachItemRef = useRef(null)
    let record = JSON.parse(sessionStorage.getItem("forStock"))
    if (record !== null) {
        const eachItem = record.map((content, index) => {
            const keys = Object.keys(content);
            const itemName = keys.find((key) => key !== 'price');
            return (
                <div key={index}>
                    <div style={{ marginBottom: "20px" }}>{itemName} * {content[itemName]}
                        <span style={{ float: "right" }}>{content[itemName] * content["price"]}$</span>
                    </div>
                </div>
            )
        })
        eachItemRef.current = eachItem
    }

    const [totalPriceFinal, settotalPrice] = useState("")
    useEffect(() => {
        let array = JSON.parse(sessionStorage.getItem("forStock"))
        let totalPrice = 0
        if (array !== null) {
            for (let i = 0; i < array.length; i++) {
                let eachTotalPrice = Object.values(array[i])[0] * Object.values(array[i])[1]
                totalPrice = totalPrice + eachTotalPrice
            }
            settotalPrice(totalPrice)
        }
    }, [])

    const [deliveryWay, setdeliveryWay] = useState("")
    const chooseDelivery = (e) => {
        let { value } = e.target
        setdeliveryWay(value)
    }
    const [payWay, setpayWay] = useState("")
    const choosePay = (e) => {
        let { value } = e.target
        setpayWay(value)
    }
    const [coupon, setcoupon] = useState("")
    const chooseCoupon = (e) => {
        let { value } = e.target
        setcoupon(value)
    }

    const [proCollection, setproCollection] = useState([])
    useEffect(() => {
        const fetchData = () => {
            getDocs(query(collection(cloudStore, "productData"), where("Product_Information", "!=", null)))
                .then((querySnapshot) => {
                    const data = querySnapshot.docs.map((doc) => doc.data());
                    setproCollection(data)
                })
        };
        fetchData(); // Fetch the data initially
        const intervalId = setInterval(() => {
            fetchData(); // Fetch the data every 3 minutes
        }, 1000 * 60 * 3);
        return () => {
            clearInterval(intervalId); // Clean up the interval when the component unmounts
        };
    }, []);

    const [ifsubmitOrder, setifsubmitOrder] = useState(false)
    const userName = localStorage.getItem("currentLoginUser");
    const submitOrder = async () => {
        let tips = document.getElementById("snackbar");
        let text = "";

        if (userName !== null && userID !== null) {
            const userExist = await getDocs(query(collection(cloudStore, "userData"), where("Personal_Information.name", "==", userName)));
            const userData = userExist.docs.map(doc => doc.data());
            let userID = userData[0].Personal_Information.userID
            const orderExist = await getDoc(doc(collection(cloudStore, 'orderInfo'), userID));
            let weChat = userData[0].Personal_Information.wechat
            let location = userData[0].Personal_Information.location
            let phone = userData[0].Personal_Information.phone
            let orderID = getRandomInt(1000, 9999) + userID
            let ifOfficer = userData[0].officer
            if (ifOfficer === false) {
                let record = JSON.parse(sessionStorage.getItem("forStock"))
                if (record !== null && record.length > 0) {
                    if (deliveryWay.length > 0 && payWay.length > 0) {
                        let ifOff = []
                        let ifstock = []
                        record.map((item) => {
                            proCollection.map((content) => {
                                const keys = Object.keys(item);
                                const itemName = keys.find((key) => key !== 'price');
                                if (content.Product_Information.proname === itemName) {
                                    if (content.LeftNum >= item[itemName]) {
                                        if (content.offShelves === false) {

                                        } else {
                                            ifOff.push(itemName)
                                        }
                                    } else {
                                        ifstock.push(itemName)
                                    }
                                }
                            })
                        })
                        if (ifstock.length > 0) {
                            text = document.createTextNode(`${ifstock} 购买量超过库存`);
                            tips.appendChild(text)
                            tips.className = "show";
                            setTimeout(() => {
                                tips.className = tips.className.replace("show", "disappearFade");
                                setTimeout(() => {
                                    tips.innerHTML = '';
                                }, 300);
                            }, 2000);
                        }
                        if (ifOff.length > 0) {
                            text = document.createTextNode(`${ifOff}已下架`);
                            tips.appendChild(text)
                            tips.className = "show";
                            setTimeout(() => {
                                tips.className = tips.className.replace("show", "disappearFade");
                                setTimeout(() => {
                                    tips.innerHTML = '';
                                }, 300);
                            }, 2000);
                        }
                        if (ifstock.length === 0 && ifOff.length === 0) {
                            if (totalPriceFinal < coupon) {
                                text = document.createTextNode("您不能使用额度大于购买额度的优惠卷。");
                                tips.appendChild(text)
                                tips.className = "show";
                                setTimeout(() => {
                                    tips.className = tips.className.replace("show", "disappearFade");
                                    setTimeout(() => {
                                        tips.innerHTML = '';
                                    }, 300);
                                }, 2000);
                            } else {
                                if (couponCollection.length > 0) {
                                    const array = couponCollection[0].Coupon_Information.金额
                                    let index = array.indexOf(parseInt(coupon))
                                    if (index !== -1) {
                                        array.splice(index, 1);
                                    }
                                    const docData2 = {
                                        "Coupon_Information.金额": array
                                    }
                                    updateDoc(doc(cloudStore, "userCoupon", userID), docData2)
                                }
                                // const docData4 = {
                                //     "会员等级.buyingPower": increment(totalPriceFinal - coupon)
                                // }
                                // updateDoc(doc(cloudStore, "userData", userID), docData4)
                                record.map((item) => {
                                    proCollection.map((content) => {
                                        const keys = Object.keys(item);
                                        const itemName = keys.find((key) => key !== 'price');
                                        if (content.Product_Information.proname === itemName) {
                                            const docData = {
                                                "LeftNum": increment(-item[itemName]),
                                                // "Earn": increment(+Object.values(itemName)[0] * Object.values(itemName)[1]),
                                                // "SellNum": increment(+Object.values(itemName)[0]),
                                                // "SellPeople": increment(+1)
                                            }
                                            updateDoc(doc(cloudStore, "productData", content.Product_Information.proID), docData)
                                        }
                                    })
                                })

                                let time = new Date()
                                let day = time.getDate();
                                let year = time.getFullYear();
                                let month = time.getMonth() + 1;
                                let hours = time.getHours().toString().padStart(2, '0');
                                let minutes = time.getMinutes().toString().padStart(2, '0');
                                let seconds = time.getSeconds().toString().padStart(2, '0');
                                let finalDate = year + "-" + month + "-" + day + " " + hours + ":" + minutes + ":" + seconds
                                if (orderExist.exists()) {
                                    const docData3 = {
                                        [finalDate]: {
                                            "orderID": orderID,
                                            "orderItem": record,
                                            "totalPrice": parseFloat(totalPriceFinal).toFixed(2),
                                            "coupon": parseFloat(coupon),
                                            "delivery": deliveryWay,
                                            "paymentMethod": payWay,
                                            "userName": userName,
                                            "userID": userID,
                                            "weChat": weChat,
                                            "location": location,
                                            "phone": phone,
                                            "status": "等待确认",
                                            "time": new Date()
                                        }
                                    }
                                    const docRef = doc(cloudStore, "orderInfo", userID);
                                    updateDoc(docRef, { User_Order: arrayUnion(docData3) }).then(() => {
                                        var text = document.createTextNode("已提交");
                                        tips.style.color = "red"
                                        tips.appendChild(text)
                                        tips.className = "show";
                                        setTimeout(() => {
                                            tips.className = tips.className.replace("show", "disappearFade");
                                            setTimeout(() => {
                                                tips.innerHTML = '';
                                            }, 300);
                                        }, 2000);
                                        setifsubmitOrder(true)
                                        const mainElement = document.querySelector("main");
                                        mainElement.style.animation = "none";
                                        mainElement.style.display = "none";
                                        void mainElement.offsetHeight;
                                        setTimeout(() => { mainElement.style.display = "block"; mainElement.style.animation = "slideUp 0.8s ease"; }, 200);
                                    })
                                } else {
                                    const docData3 = {
                                        "userID": userID,
                                        "User_Order": [{
                                            [finalDate]: {
                                                "orderID": orderID,
                                                "orderItem": record,
                                                "totalPrice": parseFloat(totalPriceFinal).toFixed(2),
                                                "coupon": parseFloat(coupon),
                                                "delivery": deliveryWay,
                                                "paymentMethod": payWay,
                                                "userName": userName,
                                                "userID": userID,
                                                "weChat": weChat,
                                                "location": location,
                                                "phone": phone,
                                                "status": "等待确认",
                                                "time": new Date()
                                            }
                                        }]
                                    }
                                    setDoc(doc(cloudStore, "orderInfo", userID), docData3).then(() => {
                                        sessionStorage.removeItem("forStock")
                                        sessionStorage.removeItem("WhatInCart")
                                        var text = document.createTextNode("已提交");
                                        tips.style.color = "red"
                                        tips.appendChild(text)
                                        tips.className = "show";
                                        setTimeout(() => {
                                            tips.className = tips.className.replace("show", "disappearFade");
                                            setTimeout(() => {
                                                tips.innerHTML = '';
                                            }, 300);
                                        }, 2000);
                                        setifsubmitOrder(true)
                                        const mainElement = document.querySelector("main");
                                        mainElement.style.animation = "none";
                                        mainElement.style.display = "none";
                                        void mainElement.offsetHeight;
                                        setTimeout(() => { mainElement.style.display = "block"; mainElement.style.animation = "slideUp 0.8s ease"; }, 200);
                                    })
                                }
                                text = document.createTextNode("请等待信息被提交.");
                                tips.appendChild(text)
                                tips.className = "show";
                                setTimeout(() => {
                                    tips.className = tips.className.replace("show", "disappearFade");
                                    setTimeout(() => {
                                        tips.innerHTML = '';
                                    }, 300);
                                }, 2000);
                            }
                        }
                    } else {
                        text = document.createTextNode("你需要填入全部信息才能提交.");
                        tips.appendChild(text)
                        tips.className = "show";
                        setTimeout(() => {
                            tips.className = tips.className.replace("show", "disappearFade");
                            setTimeout(() => {
                                tips.innerHTML = '';
                            }, 300);
                        }, 2000);
                    }
                } else {
                    text = document.createTextNode("你需要买点东西才能结算哟.");
                    tips.appendChild(text)
                    tips.className = "show";
                    setTimeout(() => {
                        tips.className = tips.className.replace("show", "disappearFade");
                        setTimeout(() => {
                            tips.innerHTML = '';
                        }, 300);
                    }, 2000);
                }
            } else {
                text = document.createTextNode("officer是不能购买哒.");
                tips.appendChild(text)
                tips.className = "show";
                setTimeout(() => {
                    tips.className = tips.className.replace("show", "disappearFade");
                    setTimeout(() => {
                        tips.innerHTML = '';
                    }, 300);
                }, 2000);
            }

        } else {
            text = document.createTextNode("请登录.");
            tips.appendChild(text)
            tips.className = "show";
            setTimeout(() => {
                tips.className = tips.className.replace("show", "disappearFade");
                setTimeout(() => {
                    tips.innerHTML = '';
                }, 300);
            }, 2000);
        }
    }

    const eachCouponRef = useRef(null)
    let userID = localStorage.getItem("currentLoginUserID");
    const [couponCollection, setcouponCollection] = useState([])
    useEffect(() => {
        if (userID !== null) {
            getDocs(query(collection(cloudStore, "userCoupon"), where("Coupon_Information.ownerID", "==", userID)))
                .then((querySnapshot) => {
                    const data = querySnapshot.docs.map((doc) => doc.data());
                    setcouponCollection(data)
                })
        }
    });

    useEffect(() => {
        if (couponCollection.length > 0) {
            couponCollection[0].Coupon_Information["金额"].sort((a, b) => a - b);
            const eachCollection = couponCollection[0].Coupon_Information["金额"].map((content, index) => {
                return (
                    <option value={content} key={index}>{content}</option>
                )
            })
            eachCouponRef.current = eachCollection
        }
    });

    return (
        <div id="summaryPrice_page">
            <Navigation />
            {ifsubmitOrder === false ?
                <>
                    <main >
                        <h1 style={{ textAlign: "center" }}>Checkout</h1>
                        <div className='totalPrice'>
                            <div>
                                {eachItemRef.current}
                            </div>
                            {deliveryWay === "商家配送(1$)" && totalPriceFinal < 45 ?
                                <>
                                    <div className='showtotalPrice'>
                                        Total: {parseFloat(totalPriceFinal).toFixed(2) + 1 - coupon}$
                                    </div>
                                </> : null
                            }
                            {deliveryWay !== "商家配送(1$)" || totalPriceFinal >= 45 ?
                                <>
                                    <div className='showtotalPrice'>
                                        Total: {parseFloat(totalPriceFinal).toFixed(2) - coupon}$
                                    </div>
                                </> :
                                null
                            }
                        </div>
                        <div className='chooseDelivery'>
                            <h1>请选优惠券(一次一张)</h1>
                            <select onChange={(e) => chooseCoupon(e)}>
                                <option value={0}>请选择</option>
                                {eachCouponRef.current}
                            </select>
                        </div>
                        <div className='chooseDelivery'>
                            <h1>请选择取货方式</h1>
                            <p>商家配送目前仅只支持u-district以内，其他地区暂时只能自取。</p>
                            <p>自提可以随时联系客服，商家配送两天配送一次。具体时间请查看主页公告板。</p>
                            <select onChange={(e) => chooseDelivery(e)}>
                                <option value="">请选择</option>
                                <option value="自取" >自取</option>
                                {totalPriceFinal >= 45 ?
                                    <>
                                        <option value="商家配送(免费)" >商家配送 (免费)</option>
                                    </> :
                                    <option value="商家配送(1$)" >商家配送 (配送费1$)</option>
                                }

                            </select>
                        </div>
                        <div className='chooseDelivery'>
                            <h1>请选择支付方式</h1>
                            <p>请按实时汇率转账。</p>
                            <select onChange={(e) => choosePay(e)}>
                                <option value="">请选择</option>
                                <option value="zelle" >zelle</option>
                                <option value="微信">微信</option>
                                <option value="支付宝" >支付宝</option>
                            </select>
                            {payWay === "zelle" ?
                                <>
                                    <div style={{ fontSize: "30px" }}>请转账至：2068028946</div>
                                </> : null
                            }
                            {payWay === "微信" ?
                                <>
                                    <div>
                                        <img
                                            src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/%E5%BE%AE%E4%BF%A1%E6%94%AF%E4%BB%98.jpg?v=1679648926647"
                                            alt="微信"
                                            className='payway' />
                                    </div>
                                </> : null
                            }
                            {payWay === "支付宝" ?
                                <>
                                    <div>
                                        <img
                                            src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/%E6%94%AF%E4%BB%98%E5%AE%9D%E6%94%AF%E4%BB%98.png?v=1679649393689"
                                            alt="支付宝"
                                            className='payway' />
                                        <div style={{ fontSize: "30px", marginTop: "20px" }}>如失败请转账至支付宝账户: foodierauw@gmail.com</div>
                                    </div>
                                </> : null
                            }
                            <div className="button submit" onClick={submitOrder}>提交</div>
                            <p>请先付款，后提交呦。</p>
                            <div id="snackbar"></div>
                        </div>
                    </main>
                </> : null
            }
            {ifsubmitOrder === true ?
                <>
                    <main>
                        <div className="afterPay">
                            <h1>您的信息已经提交，请加客服微信号发送付款信息截图以及订单号</h1>
                            <img src="https://cdn.glitch.global/538014ed-ec37-4c4b-82e0-5e1b38509deb/%E6%B7%BB%E5%8A%A0%E5%A5%BD%E5%8F%8B.jpg?v=1681973072042"
                                alt='添加好友' />
                        </div>
                        <div style={{ width: "fit-content", margin: "auto" }}>
                            <NavLink to="/main"><div className="button submit" style={{ width: "200px" }}>完成</div></NavLink>
                        </div>
                    </main>
                </> : null
            }
            <Footer />
        </div>
    );
}

function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
} 